import { FlightV2, Upgrade, VoucherType, Cabin, UpgradeProduct, PaymentOptionsV2 } from '../api/models';
import { PaymentType } from '../interfaces';

export const getUpgradeByCabin = (cabin: Cabin, upgrades: Upgrade[]): Upgrade => {
  const map = {
    [UpgradeProduct.EconomyToBusiness]: Cabin.Business,
    [UpgradeProduct.PremiumeconomyToBusiness]: Cabin.Business,
    [UpgradeProduct.EconomyToPremiumeconomy]: Cabin.Ecopremium,
  };

  return upgrades.find((upgrade: Upgrade) => {
    return cabin === map[upgrade.upgradeProductName];
  });
};

export const getCabinFromUpgrade = (upgrade: Upgrade): Cabin => {
  return getCabinFromUpgradeName(upgrade.upgradeProductName);
};

export const getCabinFromUpgradeName = (productName: UpgradeProduct): Cabin => {
  const map = {
    [UpgradeProduct.EconomyToBusiness]: Cabin.Business,
    [UpgradeProduct.PremiumeconomyToBusiness]: Cabin.Business,
    [UpgradeProduct.EconomyToPremiumeconomy]: Cabin.Ecopremium,
  };

  return map[productName];
};

export const getUpgradeFromFlight = (flight: FlightV2, productName: UpgradeProduct): Upgrade => {
  return flight.upgrades.find((upgrade) => upgrade.upgradeProductName === productName);
};

export const getPaymentFromUpgrade = <T extends keyof PaymentOptionsV2>(
  upgrade: Upgrade,
  paymentType: PaymentType
): PaymentOptionsV2[T] => upgrade.paymentOptions[paymentType] as PaymentOptionsV2[T];

export const getPaymentFromFlight = <T extends keyof PaymentOptionsV2>(
  flight: FlightV2,
  productName: UpgradeProduct,
  paymentType: PaymentType
): PaymentOptionsV2[T] => getPaymentFromUpgrade(getUpgradeFromFlight(flight, productName), paymentType);

export const getVoucherTypeFromPaymentType = (paymentType: PaymentType): VoucherType => {
  const map = {
    [PaymentType.EUROPE_UPGRADE]: VoucherType.EuropeUpgrade,
    [PaymentType.LONG_HAUL_UPGRADE]: VoucherType.LongHaulUpgrade,
    [PaymentType.UPGRADE_BENEFIT]: VoucherType.UpgradeBenefit,
  };

  return map[paymentType];
};
